<template>
  <div class="relative flex-1">
    <div class="z-10 flex flex-col md:w-[496px] mx-4 relative -mb-10 mt-10 md:mt-4">
      <GetStartedSectionsSexualHealth v-show="selectedSectionSlug === 'sexual-health'" />
      <GetStartedSectionsConsultation v-show="selectedSectionSlug === 'consultation'" />
      <GetStartedSectionsHealthAndWellness
        v-if="siteCategories.includes('health-and-wellness')"
        v-show="selectedSectionSlug === 'health-and-wellness'"
      />
    </div>

    <GetStartedModal :serviceTopicLists="[]" :titleTopicBox="{ title: '--', slug: '--' }" />
  </div>
</template>

<script setup lang="ts">
import type { GetStartedFlow } from "./types";

const route = useRoute();
const globalStore = useGlobalStore();
const siteCategories = globalStore.siteSettings?.categories ?? [];

/**
 * Currently focused section.
 */
const selectedSectionSlug = computed(() => route.params.section as GetStartedFlow);
</script>
